import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=f1b9015c&scoped=true"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&id=f1b9015c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b9015c",
  null
  
)

export default component.exports